import TailoredActionName from '../../store/schema/telemetry/TailoredActionName';
import { TxpDatapoint } from 'txp-data';
import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import { editableFlagCustomData } from '../../helpers/EditableCardConsts';

export default function populateCardViewedDatapoint(
    datapointLogger: (
        txpDatapoint: TxpDatapoint,
        datapointName: string,
        internetMessageId?: string,
        isEditableCardEnabled?: boolean
    ) => void,
    origin: string,
    entityNamesMap: number,
    internetMessageId?: string,
    isEditableCardEnabled?: boolean
) {
    let editableData = isEditableCardEnabled && editableFlagCustomData;
    if (datapointLogger) {
        const datapoint = {
            [LogNames.origin]: origin,
            [LogNames.entityNamesMap]: entityNamesMap.toString(),
            ...editableData,
        };

        datapointLogger(datapoint, TailoredActionName.CardViewed, internetMessageId);
    }
}
